import { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

interface Route {
  id: string;
  name: string;
  region: string;
  duration: string;
  difficulty: "Kolay" | "Orta" | "Zorlu";
  elevation: string;
  distance: string;
  season: string;
  highlights: string[];
  description: string;
  tips: string[];
  image: string;
  mapQuery: string;
  villages: string[];
  nearbyAccommodation: string;
}

const routes: Route[] = [
  {
    id: "ayder-kackar",
    name: "Ayder – Kaçkar Zirvesi Rotası",
    region: "Rize / Artvin",
    duration: "3-5 gün",
    difficulty: "Zorlu",
    elevation: "3.937 m",
    distance: "42 km",
    season: "Haziran – Eylül",
    highlights: ["Kaçkar Dağları", "Ayder Yaylası", "Buzul gölleri", "Alpin çayırlar"],
    description: "Türkiye'nin en yüksek dağlarından Kaçkar'a uzanan bu rota, Ayder Yaylası'nın şelale sesi eşliğinde başlar. Yüksek alpin çayırlar, buzul gölleri ve Karadeniz'in yeşil ormanlarını bir arada sunan eşsiz bir trekking deneyimidir. Deneyimli dağcılar için Türkiye'nin en zorlu ve en ödüllendirici rotalarından biridir.",
    tips: ["Rehber eşliğinde gidin", "Yüksek irtifa için önceden aklimatizasyon yapın", "Haziran'da kar olabilir", "Sığınak rezervasyonu şart"],
    image: "https://readdy.ai/api/search-image?query=Kackar%20Mountains%20Turkey%20alpine%20meadows%20glacial%20lakes%20trekking%20trail%20green%20valleys%20misty%20peaks%20dramatic%20landscape&width=900&height=500&seq=kackar-route-1&orientation=landscape",
    mapQuery: "Ayder Yaylası Rize Turkey",
    villages: ["Ayder", "Yukarı Kavrun", "Dilberdüzü"],
    nearbyAccommodation: "Ayder Doğa Glamping, Çamlıhemşin Pansiyonları",
  },
  {
    id: "uzungol-sumela",
    name: "Uzungöl – Sümela Manastırı Rotası",
    region: "Trabzon",
    duration: "2 gün",
    difficulty: "Kolay",
    elevation: "1.090 m",
    distance: "18 km",
    season: "Nisan – Kasım",
    highlights: ["Uzungöl", "Sümela Manastırı", "Altındere Vadisi", "Çay bahçeleri"],
    description: "Trabzon'un ikonik destinasyonlarını birleştiren bu rota, Uzungöl'ün sakin sularından başlayarak Altındere Vadisi'nin derinliklerine iner. Kayalıklara oyulmuş Sümela Manastırı'na ulaşmak için orman yollarını takip edersiniz. Çay bahçeleri ve fındık ormanları arasında yürüyüş yapmanın tadını çıkarın.",
    tips: ["Sümela için önceden bilet alın", "Sabah erken gidin kalabalıktan kaçının", "Yağmurluğunuzu unutmayın", "Uzungöl'de bir gece kalın"],
    image: "https://readdy.ai/api/search-image?query=Uzungol%20lake%20Turkey%20misty%20morning%20green%20forest%20mountains%20reflection%20calm%20water%20traditional%20wooden%20houses&width=900&height=500&seq=uzungol-route-1&orientation=landscape",
    mapQuery: "Uzungöl Trabzon Turkey",
    villages: ["Uzungöl", "Çaykara", "Maçka"],
    nearbyAccommodation: "Uzungöl Otel & Pansiyonları",
  },
  {
    id: "pokut-sal",
    name: "Pokut – Sal Yaylası Rotası",
    region: "Rize",
    duration: "1-2 gün",
    difficulty: "Orta",
    elevation: "2.100 m",
    distance: "12 km",
    season: "Mayıs – Ekim",
    highlights: ["Pokut Yaylası", "Sal Yaylası", "Panoramik manzara", "Geleneksel yayla evleri"],
    description: "Rize'nin gizli cenneti Pokut Yaylası, Karadeniz'in en güzel panoramik manzaralarından birini sunar. Bulutların altında kalan bu yayla, geleneksel ahşap evleri ve el değmemiş doğasıyla zaman durmuş gibi hissettirir. Sal Yaylası'na uzanan patika boyunca yabani çiçekler ve dağ keçileriyle karşılaşabilirsiniz.",
    tips: ["4x4 araç önerilir", "Yaylada konaklama imkânı sınırlı", "Fotoğraf için gün batımı muhteşem", "Yerel rehber tutun"],
    image: "https://readdy.ai/api/search-image?query=Pokut%20Yayla%20Turkey%20Black%20Sea%20highland%20traditional%20wooden%20houses%20green%20meadows%20misty%20clouds%20panoramic%20view&width=900&height=500&seq=pokut-route-1&orientation=landscape",
    mapQuery: "Pokut Yaylası Rize Turkey",
    villages: ["Pokut", "Sal", "Çat"],
    nearbyAccommodation: "Çamlıhemşin Butik Pansiyonları",
  },
  {
    id: "borcka-karagol",
    name: "Borçka Karagöl Rotası",
    region: "Artvin",
    duration: "1 gün",
    difficulty: "Kolay",
    elevation: "1.350 m",
    distance: "8 km",
    season: "Tüm yıl (Sonbahar önerilir)",
    highlights: ["Karagöl", "Sonbahar renkleri", "Orman yürüyüşü", "Piknik alanları"],
    description: "Artvin'in saklı hazinesi Karagöl, özellikle sonbaharda kızıl, sarı ve turuncu renklerin göl yüzeyine yansımasıyla büyüleyici bir manzara sunar. Kısa ama etkileyici bu rota, her yaştan yürüyüşçüye uygundur. Göl çevresindeki orman yolları boyunca yürüyerek doğanın içinde kaybolun.",
    tips: ["Ekim-Kasım sonbahar için ideal", "Hafta sonu kalabalık olabilir", "Piknik malzemesi getirin", "Fotoğraf için sabah saatleri"],
    image: "https://readdy.ai/api/search-image?query=Karagol%20Borcka%20Artvin%20Turkey%20autumn%20forest%20lake%20reflection%20colorful%20trees%20orange%20red%20yellow%20foliage&width=900&height=500&seq=karagol-route-1&orientation=landscape",
    mapQuery: "Borçka Karagöl Artvin Turkey",
    villages: ["Borçka", "Camili"],
    nearbyAccommodation: "Artvin Merkez Otelleri",
  },
  {
    id: "giresun-adasi",
    name: "Giresun Adası & Kümbet Yaylası",
    region: "Giresun",
    duration: "2 gün",
    difficulty: "Kolay",
    elevation: "1.800 m",
    distance: "15 km",
    season: "Mayıs – Ekim",
    highlights: ["Giresun Adası", "Kümbet Yaylası", "Fındık bahçeleri", "Karadeniz manzarası"],
    description: "Giresun'un eşsiz coğrafyasını keşfeden bu rota, Türkiye'nin tek yerleşim adası olan Giresun Adası'ndan başlar. Tekne turu sonrası Kümbet Yaylası'na çıkarak Karadeniz'in sonsuz mavisini ve fındık bahçelerinin yeşilini bir arada görebilirsiniz. Yöresel lezzetler ve sıcak Karadeniz misafirperverliği sizi bekliyor.",
    tips: ["Ada için tekne turu rezervasyonu yapın", "Yaylada yerel ürünler satın alın", "Akşam Giresun'da kalın", "Mayıs'ta Aksu Festivali'ni kaçırmayın"],
    image: "https://readdy.ai/api/search-image?query=Giresun%20Black%20Sea%20coast%20Turkey%20green%20hills%20hazelnut%20gardens%20coastal%20town%20panoramic%20view%20summer&width=900&height=500&seq=giresun-route-1&orientation=landscape",
    mapQuery: "Giresun Adası Turkey",
    villages: ["Giresun Adası", "Kümbet", "Dereli"],
    nearbyAccommodation: "Giresun Merkez Otelleri",
  },
  {
    id: "sinop-hamsilos",
    name: "Sinop – Hamsilos Fiyordu Rotası",
    region: "Sinop",
    duration: "1 gün",
    difficulty: "Kolay",
    elevation: "150 m",
    distance: "6 km",
    season: "Nisan – Kasım",
    highlights: ["Hamsilos Fiyordu", "Sinop Kalesi", "Tarihi liman", "Karadeniz kıyısı"],
    description: "Türkiye'nin tek doğal fiyordu olan Hamsilos, Sinop'un en etkileyici doğa harikasıdır. Kıyı boyunca uzanan bu kısa rota, derin mavi sular ve sarp kayalıklar arasında yürüyüş imkânı sunar. Sinop Kalesi ve tarihi limanı da ziyaret ederek Karadeniz'in en kuzey noktasında unutulmaz bir gün geçirin.",
    tips: ["Sinop şehir merkezini de gezip", "Balık restoranlarını deneyin", "Gün batımı için Hamsilos'a gidin", "Yaz aylarında yüzme imkânı var"],
    image: "https://readdy.ai/api/search-image?query=Sinop%20Turkey%20Black%20Sea%20coast%20fjord%20Hamsilos%20deep%20blue%20water%20cliffs%20green%20hills%20dramatic%20landscape&width=900&height=500&seq=sinop-route-1&orientation=landscape",
    mapQuery: "Hamsilos Fiyordu Sinop Turkey",
    villages: ["Hamsilos", "Sinop Merkez"],
    nearbyAccommodation: "Sinop Butik Otelleri",
  },
];

const difficultyColors: Record<string, string> = {
  "Kolay": "bg-emerald-100 text-emerald-700",
  "Orta": "bg-amber-100 text-amber-700",
  "Zorlu": "bg-rose-100 text-rose-700",
};

const difficultyIcons: Record<string, string> = {
  "Kolay": "ri-walk-line",
  "Orta": "ri-run-line",
  "Zorlu": "ri-landscape-line",
};

const REGIONS = ["Tümü", "Rize / Artvin", "Trabzon", "Rize", "Artvin", "Giresun", "Sinop"];
const DIFFICULTIES = ["Tümü", "Kolay", "Orta", "Zorlu"];

const BlackSeaGuide = () => {
  const [selectedRoute, setSelectedRoute] = useState<Route | null>(null);
  const [filterRegion, setFilterRegion] = useState("Tümü");
  const [filterDifficulty, setFilterDifficulty] = useState("Tümü");
  const [showMap, setShowMap] = useState(false);

  const filtered = routes.filter((r) => {
    const matchRegion = filterRegion === "Tümü" || r.region === filterRegion;
    const matchDiff = filterDifficulty === "Tümü" || r.difficulty === filterDifficulty;
    return matchRegion && matchDiff;
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero */}
      <div className="relative pt-20 overflow-hidden" style={{ minHeight: 520 }}>
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Black%20Sea%20Turkey%20Karadeniz%20green%20mountains%20misty%20valleys%20highland%20yayla%20panoramic%20aerial%20view%20lush%20forest%20dramatic%20clouds&width=1400&height=600&seq=blacksea-hero-bg&orientation=landscape"
            alt="Karadeniz Yayla Rehberi"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/60"></div>
        </div>
        <div className="relative max-w-5xl mx-auto px-4 md:px-8 py-20 text-center">
          <div className="flex items-center justify-center gap-2 mb-4">
            <span className="inline-block bg-emerald-500/20 border border-emerald-400/40 text-emerald-300 text-xs font-semibold px-4 py-1.5 rounded-full uppercase tracking-widest">
              Doğa Rehberi
            </span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
            Karadeniz Yayla Rotaları
          </h1>
          <p className="text-stone-200 text-base max-w-2xl mx-auto mb-8 leading-relaxed">
            Türkiye'nin en yeşil coğrafyasında, bulutların üzerindeki yaylalardan buzul göllerine uzanan 6 eşsiz rota. Kaçkar'dan Sinop'a Karadeniz'i keşfedin.
          </p>
          <div className="flex items-center justify-center gap-6 flex-wrap">
            <div className="flex items-center gap-2 text-white/80 text-sm">
              <i className="ri-map-pin-line text-emerald-400"></i>
              <span>6 Rota</span>
            </div>
            <div className="flex items-center gap-2 text-white/80 text-sm">
              <i className="ri-map-2-line text-emerald-400"></i>
              <span>6 İl</span>
            </div>
            <div className="flex items-center gap-2 text-white/80 text-sm">
              <i className="ri-calendar-line text-emerald-400"></i>
              <span>4 Mevsim</span>
            </div>
            <div className="flex items-center gap-2 text-white/80 text-sm">
              <i className="ri-walk-line text-emerald-400"></i>
              <span>Her Seviyeye Uygun</span>
            </div>
          </div>
        </div>
      </div>

      {/* Quick Stats */}
      <div className="bg-stone-900 py-6">
        <div className="max-w-5xl mx-auto px-4 md:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {[
              { icon: "ri-walk-line", label: "Kolay Rotalar", value: "3", color: "text-emerald-400" },
              { icon: "ri-run-line", label: "Orta Rotalar", value: "1", color: "text-amber-400" },
              { icon: "ri-landscape-line", label: "Zorlu Rotalar", value: "2", color: "text-rose-400" },
              { icon: "ri-sun-line", label: "En İyi Sezon", value: "Yaz", color: "text-yellow-400" },
            ].map((s) => (
              <div key={s.label} className="text-center">
                <div className={`text-2xl font-bold ${s.color}`}>{s.value}</div>
                <div className="text-stone-400 text-xs mt-1">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-8 py-10">

        {/* Filters */}
        <div className="flex flex-col sm:flex-row gap-4 mb-8 items-start sm:items-center justify-between">
          <div>
            <h2 className="text-xl font-bold text-stone-900" style={{ fontFamily: "'Playfair Display', serif" }}>
              Tüm Rotalar
            </h2>
            <p className="text-stone-400 text-sm mt-0.5">{filtered.length} rota listeleniyor</p>
          </div>
          <div className="flex items-center gap-3 flex-wrap">
            <select
              value={filterRegion}
              onChange={(e) => setFilterRegion(e.target.value)}
              className="border border-stone-200 rounded-xl px-4 py-2 text-sm text-stone-700 outline-none focus:border-emerald-400 bg-white cursor-pointer"
            >
              {REGIONS.map((r) => <option key={r} value={r}>{r === "Tümü" ? "Tüm Bölgeler" : r}</option>)}
            </select>
            <div className="flex items-center bg-stone-100 rounded-xl p-1 gap-1">
              {DIFFICULTIES.map((d) => (
                <button
                  key={d}
                  onClick={() => setFilterDifficulty(d)}
                  className={`px-3 py-1.5 rounded-lg text-xs font-medium transition-all cursor-pointer whitespace-nowrap ${
                    filterDifficulty === d ? "bg-white text-stone-800" : "text-stone-500 hover:text-stone-700"
                  }`}
                >
                  {d}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Route Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-12">
          {filtered.map((route) => (
            <div
              key={route.id}
              className="bg-white rounded-2xl border border-stone-100 overflow-hidden group hover:border-emerald-200 transition-all cursor-pointer"
              onClick={() => setSelectedRoute(route)}
            >
              {/* Image */}
              <div className="relative h-52 overflow-hidden">
                <img
                  src={route.image}
                  alt={route.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                {/* Difficulty badge */}
                <div className="absolute top-3 left-3">
                  <span className={`flex items-center gap-1.5 text-xs px-3 py-1 rounded-full font-semibold ${difficultyColors[route.difficulty]}`}>
                    <i className={difficultyIcons[route.difficulty]}></i>
                    {route.difficulty}
                  </span>
                </div>
                {/* Season badge */}
                <div className="absolute top-3 right-3">
                  <span className="flex items-center gap-1 bg-black/50 backdrop-blur-sm text-white text-xs px-2.5 py-1 rounded-full">
                    <i className="ri-calendar-line text-xs"></i>
                    {route.season}
                  </span>
                </div>
                {/* Bottom info */}
                <div className="absolute bottom-3 left-3 right-3">
                  <h3 className="text-white font-bold text-lg leading-tight mb-1" style={{ fontFamily: "'Playfair Display', serif" }}>
                    {route.name}
                  </h3>
                  <div className="flex items-center gap-3 flex-wrap">
                    <span className="flex items-center gap-1 text-white/80 text-xs">
                      <i className="ri-map-pin-line text-emerald-400"></i>
                      {route.region}
                    </span>
                    <span className="flex items-center gap-1 text-white/80 text-xs">
                      <i className="ri-time-line text-emerald-400"></i>
                      {route.duration}
                    </span>
                    <span className="flex items-center gap-1 text-white/80 text-xs">
                      <i className="ri-route-line text-emerald-400"></i>
                      {route.distance}
                    </span>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="p-5">
                <p className="text-stone-500 text-sm leading-relaxed mb-4 line-clamp-2">{route.description}</p>

                {/* Highlights */}
                <div className="flex flex-wrap gap-1.5 mb-4">
                  {route.highlights.map((h) => (
                    <span key={h} className="bg-emerald-50 text-emerald-700 text-xs px-2.5 py-1 rounded-full font-medium">
                      {h}
                    </span>
                  ))}
                </div>

                {/* Stats row */}
                <div className="flex items-center gap-4 pt-3 border-t border-stone-50">
                  <div className="flex items-center gap-1.5 text-xs text-stone-500">
                    <i className="ri-arrow-up-line text-stone-400"></i>
                    <span>{route.elevation}</span>
                  </div>
                  <div className="flex items-center gap-1.5 text-xs text-stone-500">
                    <i className="ri-route-line text-stone-400"></i>
                    <span>{route.distance}</span>
                  </div>
                  <div className="ml-auto">
                    <button
                      onClick={(e) => { e.stopPropagation(); setSelectedRoute(route); }}
                      className="flex items-center gap-1.5 px-4 py-2 bg-emerald-500 hover:bg-emerald-600 text-white text-xs font-semibold rounded-xl transition-colors cursor-pointer whitespace-nowrap"
                    >
                      <i className="ri-information-line"></i>
                      Detaylar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Seasonal Guide */}
        <div className="mb-12">
          <h2 className="text-xl font-bold text-stone-900 mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
            Mevsimsel Rehber
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {[
              {
                season: "İlkbahar",
                months: "Nisan – Mayıs",
                icon: "ri-plant-line",
                color: "bg-emerald-50 border-emerald-200",
                textColor: "text-emerald-700",
                desc: "Çiçek açan yaylalar, şelale debisi en yüksek. Kar hâlâ yüksek rakımlarda.",
                routes: ["Sinop – Hamsilos", "Giresun Adası"],
              },
              {
                season: "Yaz",
                months: "Haziran – Ağustos",
                icon: "ri-sun-line",
                color: "bg-amber-50 border-amber-200",
                textColor: "text-amber-700",
                desc: "Tüm rotalar açık. Kaçkar zirvesi için en ideal dönem. Yaylalar canlı.",
                routes: ["Ayder – Kaçkar", "Pokut – Sal"],
              },
              {
                season: "Sonbahar",
                months: "Eylül – Kasım",
                icon: "ri-leaf-line",
                color: "bg-orange-50 border-orange-200",
                textColor: "text-orange-700",
                desc: "Kızıl ormanlar, Karagöl için en güzel dönem. Serin ve sakin.",
                routes: ["Borçka Karagöl", "Uzungöl – Sümela"],
              },
              {
                season: "Kış",
                months: "Aralık – Mart",
                icon: "ri-snowy-line",
                color: "bg-sky-50 border-sky-200",
                textColor: "text-sky-700",
                desc: "Yüksek rotalar kapalı. Sinop ve kıyı rotaları ziyaret edilebilir.",
                routes: ["Sinop – Hamsilos"],
              },
            ].map((s) => (
              <div key={s.season} className={`rounded-2xl border p-5 ${s.color}`}>
                <div className={`flex items-center gap-2 mb-3 ${s.textColor}`}>
                  <i className={`${s.icon} text-lg`}></i>
                  <div>
                    <p className="font-bold text-sm">{s.season}</p>
                    <p className="text-xs opacity-70">{s.months}</p>
                  </div>
                </div>
                <p className="text-stone-600 text-xs leading-relaxed mb-3">{s.desc}</p>
                <div className="space-y-1">
                  {s.routes.map((r) => (
                    <div key={r} className="flex items-center gap-1.5 text-xs text-stone-500">
                      <i className="ri-checkbox-circle-line text-emerald-500"></i>
                      {r}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Practical Info */}
        <div className="bg-stone-50 rounded-2xl p-8 mb-12 border border-stone-100">
          <h2 className="text-xl font-bold text-stone-900 mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
            Pratik Bilgiler
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              { icon: "ri-car-line", title: "Ulaşım", desc: "Yüksek yaylalara 4x4 araç önerilir. Trabzon, Rize ve Artvin'e uçuş bağlantısı mevcuttur." },
              { icon: "ri-first-aid-kit-line", title: "Sağlık", desc: "Yüksek irtifa için aklimatizasyon yapın. İlk yardım çantası ve sigorta şart." },
              { icon: "ri-hotel-line", title: "Konaklama", desc: "Yaylalarda pansiyon ve glamping seçenekleri mevcut. Yaz aylarında önceden rezervasyon yapın." },
              { icon: "ri-restaurant-line", title: "Yemek", desc: "Karadeniz mutfağı: mısır ekmeği, hamsi, kuymak, muhlama. Yerel pansiyonlarda ev yemeği." },
              { icon: "ri-phone-line", title: "Acil Durum", desc: "Dağ kurtarma: 156. Jandarma: 156. Bazı yaylalarda GSM çekmiyor, telsiz önerin." },
              { icon: "ri-shield-check-line", title: "Güvenlik", desc: "Rehber eşliğinde gidin. Hava durumunu takip edin. Kaçkar'da ani hava değişimi olabilir." },
            ].map((info) => (
              <div key={info.title} className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-white rounded-xl border border-stone-200 flex-shrink-0">
                  <i className={`${info.icon} text-stone-600 text-lg`}></i>
                </div>
                <div>
                  <p className="font-semibold text-stone-800 text-sm mb-1">{info.title}</p>
                  <p className="text-stone-500 text-xs leading-relaxed">{info.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          <div className="bg-emerald-900 rounded-2xl p-7 relative overflow-hidden">
            <div className="absolute inset-0 opacity-20">
              <img src="https://readdy.ai/api/search-image?query=Karadeniz%20Turkey%20green%20forest%20mountains%20texture%20abstract%20nature%20background&width=600&height=300&seq=blacksea-cta-1&orientation=landscape" alt="" className="w-full h-full object-cover object-top" />
            </div>
            <div className="relative">
              <div className="w-10 h-10 flex items-center justify-center bg-emerald-500/30 rounded-xl mb-4">
                <i className="ri-hotel-line text-emerald-300 text-xl"></i>
              </div>
              <h3 className="text-lg font-bold text-white mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
                Konaklama Bul
              </h3>
              <p className="text-emerald-200 text-sm mb-4">Karadeniz'deki onaylı otel ve pansiyonları keşfedin.</p>
              <Link
                to="/accommodations"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-emerald-500 hover:bg-emerald-400 text-white text-sm font-semibold rounded-xl transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-building-2-line"></i>
                Konaklamaları Gör
              </Link>
            </div>
          </div>
          <div className="bg-stone-900 rounded-2xl p-7 relative overflow-hidden">
            <div className="absolute inset-0 opacity-20">
              <img src="https://readdy.ai/api/search-image?query=Turkey%20travel%20guide%20map%20route%20planning%20adventure%20nature&width=600&height=300&seq=blacksea-cta-2&orientation=landscape" alt="" className="w-full h-full object-cover object-top" />
            </div>
            <div className="relative">
              <div className="w-10 h-10 flex items-center justify-center bg-amber-500/30 rounded-xl mb-4">
                <i className="ri-article-line text-amber-300 text-xl"></i>
              </div>
              <h3 className="text-lg font-bold text-white mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
                Seyahat Yazıları
              </h3>
              <p className="text-stone-300 text-sm mb-4">Karadeniz deneyimlerini anlatan editör yazılarını okuyun.</p>
              <Link
                to="/articles"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-amber-500 hover:bg-amber-600 text-white text-sm font-semibold rounded-xl transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-book-open-line"></i>
                Yazıları Oku
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Route Detail Modal */}
      {selectedRoute && (
        <div className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center p-4" onClick={() => setSelectedRoute(null)}>
          <div
            className="bg-white rounded-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Modal Image */}
            <div className="relative h-56 overflow-hidden rounded-t-2xl">
              <img src={selectedRoute.image} alt={selectedRoute.name} className="w-full h-full object-cover object-top" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
              <button
                onClick={() => setSelectedRoute(null)}
                className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center bg-black/40 hover:bg-black/60 text-white rounded-full cursor-pointer transition-colors"
              >
                <i className="ri-close-line"></i>
              </button>
              <div className="absolute bottom-4 left-4 right-4">
                <span className={`inline-flex items-center gap-1.5 text-xs px-3 py-1 rounded-full font-semibold mb-2 ${difficultyColors[selectedRoute.difficulty]}`}>
                  <i className={difficultyIcons[selectedRoute.difficulty]}></i>
                  {selectedRoute.difficulty}
                </span>
                <h2 className="text-white text-xl font-bold" style={{ fontFamily: "'Playfair Display', serif" }}>
                  {selectedRoute.name}
                </h2>
                <p className="text-white/70 text-sm">{selectedRoute.region}</p>
              </div>
            </div>

            <div className="p-6">
              {/* Stats */}
              <div className="grid grid-cols-4 gap-3 mb-5">
                {[
                  { icon: "ri-time-line", label: "Süre", value: selectedRoute.duration },
                  { icon: "ri-route-line", label: "Mesafe", value: selectedRoute.distance },
                  { icon: "ri-arrow-up-line", label: "Yükseklik", value: selectedRoute.elevation },
                  { icon: "ri-calendar-line", label: "Sezon", value: selectedRoute.season.split("–")[0].trim() },
                ].map((s) => (
                  <div key={s.label} className="bg-stone-50 rounded-xl p-3 text-center">
                    <i className={`${s.icon} text-stone-400 text-sm`}></i>
                    <p className="text-xs font-bold text-stone-800 mt-1">{s.value}</p>
                    <p className="text-xs text-stone-400">{s.label}</p>
                  </div>
                ))}
              </div>

              {/* Description */}
              <p className="text-stone-600 text-sm leading-relaxed mb-5">{selectedRoute.description}</p>

              {/* Highlights */}
              <div className="mb-5">
                <p className="text-xs font-semibold text-stone-500 uppercase tracking-wider mb-2">Öne Çıkanlar</p>
                <div className="flex flex-wrap gap-2">
                  {selectedRoute.highlights.map((h) => (
                    <span key={h} className="bg-emerald-50 text-emerald-700 text-xs px-3 py-1 rounded-full font-medium">{h}</span>
                  ))}
                </div>
              </div>

              {/* Villages */}
              <div className="mb-5">
                <p className="text-xs font-semibold text-stone-500 uppercase tracking-wider mb-2">Güzergah Köyleri</p>
                <div className="flex flex-wrap gap-2">
                  {selectedRoute.villages.map((v) => (
                    <span key={v} className="flex items-center gap-1 bg-stone-100 text-stone-600 text-xs px-3 py-1 rounded-full">
                      <i className="ri-map-pin-line text-xs"></i>
                      {v}
                    </span>
                  ))}
                </div>
              </div>

              {/* Tips */}
              <div className="mb-5 bg-amber-50 rounded-xl p-4 border border-amber-100">
                <p className="text-xs font-semibold text-amber-700 uppercase tracking-wider mb-3">
                  <i className="ri-lightbulb-line mr-1"></i>İpuçları
                </p>
                <ul className="space-y-2">
                  {selectedRoute.tips.map((tip, i) => (
                    <li key={i} className="flex items-start gap-2 text-xs text-amber-800">
                      <i className="ri-checkbox-circle-line text-amber-500 mt-0.5 flex-shrink-0"></i>
                      {tip}
                    </li>
                  ))}
                </ul>
              </div>

              {/* Accommodation */}
              <div className="mb-5">
                <p className="text-xs font-semibold text-stone-500 uppercase tracking-wider mb-2">Yakın Konaklama</p>
                <p className="text-sm text-stone-600">{selectedRoute.nearbyAccommodation}</p>
              </div>

              {/* Map */}
              <div className="rounded-xl overflow-hidden border border-stone-100 mb-5" style={{ height: 220 }}>
                <iframe
                  title={selectedRoute.name}
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  loading="lazy"
                  allowFullScreen
                  referrerPolicy="no-referrer-when-downgrade"
                  src={`https://maps.google.com/maps?q=${encodeURIComponent(selectedRoute.mapQuery)}&z=11&output=embed`}
                ></iframe>
              </div>

              <div className="flex gap-3">
                <Link
                  to="/accommodations"
                  className="flex-1 flex items-center justify-center gap-2 py-2.5 bg-emerald-500 hover:bg-emerald-600 text-white text-sm font-semibold rounded-xl transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-hotel-line"></i> Konaklama Bul
                </Link>
                <button
                  onClick={() => setSelectedRoute(null)}
                  className="px-5 py-2.5 border border-stone-200 text-stone-600 text-sm font-semibold rounded-xl hover:bg-stone-50 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Kapat
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default BlackSeaGuide;
